// extracted by mini-css-extract-plugin
export default {"card":"gTpdfqa3lswgzKKjBNhl","container":"zi5XBn497ktcwhAsfKcO"};